<template>
  <div class="parent-box">
    <el-date-picker
      v-model="filterDate"
      type="datetimerange"
      @change="filterChanged"
      :picker-options="pickerOptions"
      range-separator="-"
      start-placeholder="Start date"
      end-placeholder="End date"
      align="center"
    ></el-date-picker>

    <!-- <div class="content-box">
      <button
        @click="gotoPrev"
        class="button"
        type="button"
        :disabled="isFirstItem()"
      >
        <i class="fa fa-chevron-left"></i>
      </button>
      <button
        @click="toggleCalender"
        class="button button--center"
        type="button"
      >{{ currentDateFilter.label }}</button>
      <button @click="gotoNext" class="button" type="button" :disabled="isLastItem()">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="calender" v-if="show">
      <div class="calender-content">
        <button @click="closeCalender" class="calender-button button" type="button">
          <i class="fa fa-close"></i>
        </button>

        <div class="calender-inner-content">
          <div class="ranges-box">
            <h3>Quick ranges</h3>
            <div class="quick-range">
              <button
                @click="onClickQuickRange(item)"
                v-for="(item, index) in quickRanges"
                :key="index"
              >{{ item.label }}</button>
            </div>
          </div>

          <div class="custom-div">
            <h3>Custom</h3>
            <div class="custom">
              <div class="custom-time">
                <h4>From</h4>
                <div>
                  <button class="button">2020-08-02</button>
                  <button class="button">00:00</button>
                </div>
              </div>
              <div class="custom-time">
                <h4>To</h4>
                <div>
                  <button class="button">2020-08-02</button>
                  <button class="button">00:00</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import moment from "moment";

export default {
  name: "custom-date-picker",
  props: ["callbackFunc"],
  data() {
    return {
      show: false,
      currentDateFilter: {},
      // custom component
      quickRanges: [
        { label: "Last 2 days", number: "2", value: "day" },
        { label: "Yesterday", number: "1", value: "day" },
        { label: "Today", number: "0", value: "day" },
        { label: "Last hour", number: "1", value: "hour" },
        { label: "Last 7 days", number: "7", value: "day" },
        { label: "Day before", number: "1", value: "day" },
        { label: "This week", number: "0", value: "week" },
        { label: "Last 3 hours", number: "3", value: "hour" },
        { label: "Last 30 days", number: "30", value: "day" },
        { label: "This day last week", number: "7", value: "day" },
        { label: "This month", number: "0", value: "month" },
        { label: "Last 6 hours", number: "6", value: "hour" },
        { label: "Last 90 days", number: "90", value: "day" },
        { label: "Previous week", number: "1", value: "week" },
        { label: "This year", number: "0", value: "year" },
        { label: "Last 2 hours", number: "2", value: "hour" },
        { label: "Last 6 months", number: "6", value: "month" },
        { label: "Previous month", number: "1", value: "month" },
        { label: "Last year", number: "1", value: "year" },
        { label: "Last 2 hours", number: "2", value: "hour" }
      ],

      // plugin
      filterDate: [moment().startOf("day"), moment()],
      viewDataLoading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "Today",
            onClick(picker) {
              const start = moment().startOf("day");
              const end = moment();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "This week",
            onClick(picker) {
              const start = moment().startOf("week");
              const end = moment();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "This month",
            onClick(picker) {
              const start = moment().startOf("month");
              const end = moment();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "This year",
            onClick(picker) {
              const start = moment().startOf("year");
              const end = moment();
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 7 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 30 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {},
  components: {
    "el-date-picker": DatePicker
  },
  methods: {
    toggleCalender() {
      this.show = !this.show;
    },
    openCalender() {
      this.show = true;
    },
    closeCalender() {
      this.show = false;
    },
    filterChanged() {
      this.viewDataLoading = true;
      this.filterChart();
    },
    filterChart() {
      this.loading = true;
      this.filterDate
        ? this.callbackFunc(this.filterDate[0], this.filterDate[1], 1000)
        : this.callbackFunc();
    },
    gotoNext() {
      const nextIndex = this.quickRanges.indexOf(this.currentDateFilter) + 1;
      this.onClickQuickRange(this.quickRanges[nextIndex]);
    },
    gotoPrev() {
      const prevIndex = this.quickRanges.indexOf(this.currentDateFilter) - 1;
      this.onClickQuickRange(this.quickRanges[prevIndex]);
    },
    isFirstItem() {
      const currentIndex = this.quickRanges.indexOf(this.currentDateFilter);
      return currentIndex === 0 ? true : false;
    },
    isLastItem() {
      const currentIndex = this.quickRanges.indexOf(this.currentDateFilter);
      return currentIndex === this.quickRanges.length - 1 ? true : false;
    },
    onClickQuickRange(item) {
      let durationOne;
      let durationMany;
      switch (item.value) {
        case "hour":
          durationOne = "hour";
          durationMany = "hours";
          break;
        case "day":
          durationOne = "day";
          durationMany = "days";
          break;
        case "week":
          durationOne = "week";
          durationMany = "weeks";
          break;
        case "month":
          durationOne = "month";
          durationMany = "months";
          break;
        case "year":
          durationOne = "year";
          durationMany = "years";
          break;

        default:
          durationOne = "day";
          durationMany = "days";
          break;
      }
      if (item.number === "0") {
        this.callbackFunc(moment().startOf(durationOne));
      } else {
        this.callbackFunc(moment().subtract(item.number, durationMany));
      }
      this.currentDateFilter = item;
      this.closeCalender();
    }
  },
  mounted() {
    this.onClickQuickRange(this.quickRanges[0]);
  }
};
</script>

<style lang="scss" scoped>
.parent-box {
  position: relative;
}

.content-box {
  display: flex;
  margin-bottom: 20px;
}

.button {
  border: 1px solid #ccc;
  padding: 12px;
  border-radius: 6px;
  color: #999;
  background-color: inherit;
  margin-right: 5px;

  &--center {
    padding: 12px 32px;
  }
}

.calender {
  position: absolute;
  background-color: white;
  border: 1px solid #dcdbd7;
  box-shadow: 0 0 10px rgba(99, 99, 95, 0.2);
  border-radius: 12px;
  width: 120rem;
  max-width: calc(100% - 2rem);
  z-index: 10;
  top: 0;
  left: 0;
  padding: 3rem 3rem 3rem 3rem;
  transform: translateX(-120px) translateY(60px) translateZ(0px);
}

.calender-content {
  position: relative;
}

.calender-button {
  position: absolute;
  right: 0;
  top: 0;
}

.calender-inner-content {
  display: flex;

  h3 {
    font-size: 2.6rem;
    margin-bottom: 2rem;
  }
}

.ranges-box {
  flex-grow: 1;
  border-right: 1px solid #f4f4f4;

  button {
    background: transparent;
    border: 0;
    display: block;
    padding: 10px 0;
    color: #999;

    &:hover {
      color: rgb(71, 144, 208);
    }
  }
}

.custom-div {
  flex-shrink: 0;
  flex-basis: 300px;
  margin-left: 30px;
}

.custom-time {
  div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: space-between;
  }
}

.ranges {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.quick-range {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  button {
    text-align: left;
  }
}

button[disabled="disabled"] {
  color: rgba(225, 225, 225, 0.5);
  border: 1px solid rgba(225, 225, 225, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customDatePicker.vue